import { render } from "./BookingRoom.vue?vue&type=template&id=e26d5750"
import script from "./BookingRoom.vue?vue&type=script&lang=js"
export * from "./BookingRoom.vue?vue&type=script&lang=js"

import "./BookingRoom.vue?vue&type=style&index=0&id=e26d5750&lang=css"

import exportComponent from "/Users/teguhsangra/Web/GSD/xsport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__